









import { Vue, Component } from 'vue-property-decorator';
import { fetchBaseInfo } from './api';
import Music from './components/Music.vue';

@Component({
  components: {
    Music,
  },
})
export default class Home extends Vue {
  created() {
    fetchBaseInfo().then((res: any) => {
      this.$addPv(res.activityId);
      // 分享
      this.$appShareInfo({
        title: '2020两会圆桌',
        url: window.location.href,
        subtitle: '2020两会圆桌',
        classId: -1,
        id: -1,
        image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
        type: 3,
      });
      this.$wxShareInfo({
        title: '2020两会圆桌',
        subtitle: '2020两会圆桌',
        image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      });
    });
  }
}
